import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getRestaurantDetails, getOrderDetails } from '../../dashboard/reducer';
import { orderDate, orderTime } from '../../dashboard/actions';
import RestaurantAvailableDates from './RestaurantAvailableDates';
import RestaurantAvailableTimings from './RestaurantAvailableTimings';

class RestaurantAvailability extends React.Component {
  constructor(props) {
    super(props);
    this.dateSelected = this.dateSelected.bind(this);
    this.timeSelected = this.timeSelected.bind(this);

    this.state = {
      orderDate: this.props.orderDetails.orderDate,
      orderTime: this.props.orderDetails.orderTime || '',
      dateChanged: false,
    };
  }

  changedDate() {
    this.setState({
      dateChanged: true,
    });
  }
  dateSelected(date) {
    this.setState({
      orderDate: date,
      dateChanged: true,
    });
    this.props.actions.orderDate(date);
  }

  timeSelected(time) {
    this.setState({
      orderTime: time,
    });
    this.props.actions.orderTime(time);
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
          <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-12 col-lg-6">
              <RestaurantAvailableDates
                selectedDate={this.props.orderDetails.orderDate}
                dateSelected={date => this.dateSelected(date)}
                changedDate={() => this.changedDate()}
                maxAdvanceDays={
                  this.props.restaurantConfigurations.maxAdvanceNoticeDays
                }
                nextDay={this.props.nextDay}
                compareDay={this.props.compareDay}
              />
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12 col-lg-6">
              <RestaurantAvailableTimings
                selectedDate={this.state.orderDate}
                selectedTime={this.props.orderDetails.orderTime}
                timeSelected={time => this.timeSelected(time)}
                minimumNoticeTime={
                  this.props.restaurantConfigurations.minAdvanceNoticeTime
                }
                weekDayConfiguration={
                  this.props.restaurantConfigurations.hoursOfOperation
                }
                compareDay={this.props.compareDay}
                dateChanged={this.state.dateChanged}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  restaurantConfigurations: getRestaurantDetails(state),
  orderDetails: getOrderDetails(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      orderDate,
      orderTime,
    },
    dispatch
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RestaurantAvailability);



// WEBPACK FOOTER //
// ./src/views/checkout/components/RestaurantAvailability.jsx